import axios from 'axios';
import { clearSentryUser } from '../errors/sentry-user';
import { appInDevMode } from './helpers';
import { useNotifications } from '../store/notifications.store';

const transport = axios.create({
	withCredentials: true,
});

transport.interceptors.response.use(
	(response) => response,
	(error) => {
		if (appInDevMode() && error?.response?.status !== 429) {
			const notificationsStore = useNotifications();
			notificationsStore.notify(error.message, 'error');
		}

		if (error?.response != null && error?.response?.status === 401) {
			localStorage.removeItem('user');
			clearSentryUser();

			if (error?.config?.url !== '/login') {
				window.location.href = '/login';
			}
		}

		// Handle 402 Payment Required (Soft Lock)
		if (error?.response != null && error?.response?.status === 402) {
			const notificationsStore = useNotifications();
			const message = error?.response?.data?.message || 'Your account is temporarily restricted due to payment failure. Please update your payment method.';

			// Keyed, as every request the soft lock refuses answers 402: they share one toast.
			notificationsStore.notify(message, 'error', false, '/settings?tab=billing', 'Update Payment', null, {
				key: 'payment-required',
			});
		}

		return Promise.reject(error);
	});

export default transport;
